<template>
  <v-dialog
    v-model="show"
    :max-width="579"
    @click:outside="handleHideModal"
    @keydown.esc="$emit('hideModal')"
  >
    <v-card>
      <v-card-text class="text-left pt-6">
        <p class="h6 pt-2">
          {{ $t('common.validation_request') }}
        </p>
        <p class="body-1 mb-6">
          {{ $t('common.notify_corresponding_department') }}
        </p>
        <p class="body-1 mb-6">
          {{ $t('rev.validation.assign_the_requirement') }}
        </p>
        <AssigneesSelector
          hideLabel
          :blacklist="assigneesSelectorBlacklist"
          :selectedAccountIds="form.assignee ? [form.assignee] : []"
          :buttonText="$t('common.assignee_optional')"
          :filters="{ canDoFinancialValidation: true }"
          @change="handleChangeAssignees"
        />
        <div class="d-flex justify-end pt-4">
          <Button
            plain
            class="pr-8"
            color="grey"
            data-testid="validatedRequestModal-button-cancel"
            :text="$t('common.button.cancel')"
            @click="handleHideModal"
          />
          <Button
            color="primary"
            data-testid="validatedRequestModal-button-send"
            :text="$t('common.button.send')"
            @click="handleValidationRequest"
          />
        </div>
      </v-card-text>
    </v-card>
  </v-dialog>
</template>

<script>
import { mapGetters } from 'vuex'

import access from '@/lib/access'
import trackerMixin from '@/mixins/tracking/trackerMixin.vue'
import mixin from '@/mixins/mixin.vue'

import Button from '@/components/UI/Button'
import AssigneesSelector from '@/components/AssigneesSelector/AssigneesSelector.vue'

export default {
  name: 'RequestValidationModal',
  mixins: [mixin, trackerMixin],
  components: {
    Button,
    AssigneesSelector,
  },

  props: {
    show: {
      type: Boolean,
      required: true,
    },
  },
  data() {
    return {
      form: {
        assignee: null,
      },
    }
  },
  methods: {
    handleHideModal() {
      this.$emit('hideModal')
      this.form.assignee = null
    },

    handleValidationRequest() {
      this.trackValidationRequest({
        action: 'sendRequest',
        type: 'buttonClick',
      })
      this.$emit('createValidationRequest', this.form.assignee)
      this.handleHideModal()
    },

    handleChangeAssignees(assignee) {
      this.form.assignee = assignee?.[0]
    },
  },
  computed: {
    ...mapGetters(['account', 'organizationId']),

    assigneesSelectorBlacklist() {
      const accountCanDoFinancialValidation = access.isLeadershipOrFinancialCoach(
        this.account
      )

      return accountCanDoFinancialValidation ? [] : [this.account.id]
    },
  },
}
</script>
